import { render, staticRenderFns } from "./channelIndex.vue?vue&type=template&id=92db3c86"
import script from "./channelIndex.vue?vue&type=script&lang=js"
export * from "./channelIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports